// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3051":"5ed0d312","5782":"f051ebe5","8639":"d421f4e8","9582":"6368c2fb"}[chunkId] + ".chunk.css";
};